"use client";

import { create } from "zustand";

interface NavLoaderState {
    visible: boolean;
    show: () => void;
    hide: () => void;
}

/** Global fullscreen-loader overlay for the brief window during which a
 *  hard navigation (window.location.href = "...") has been triggered
 *  but the destination page hasn't rendered yet. Without this, mobile
 *  browsers continue painting the previous page while the next one
 *  loads, which on iOS Safari shows up as a noticeable «прежний
 *  экран мелькнул» before the new screen arrives. */
export const useNavLoader = create<NavLoaderState>((set) => ({
    visible: false,
    show: () => set({ visible: true }),
    hide: () => set({ visible: false }),
}));

/** Helper: show the loader, then in the next animation frame trigger
 *  a hard navigation. The animation frame guarantees the loader has
 *  been painted before the browser starts unloading the page. */
export function showNavLoaderAndNavigate(href: string) {
    if (typeof window === "undefined") return;
    useNavLoader.getState().show();
    requestAnimationFrame(() => {
        window.location.href = href;
    });
}
